export const AddTrustedSiteObserver: PerformanceObserverCallback = (entryList, observer) => {
	const script = document.createElement('script')
	script.src = 'https://cdn.ywxi.net/js/1.js'
	script.async = true
	document.body.appendChild(script)
	observer.disconnect()
}
